import {
  InsertDriveFile,
  Folder,
  Image,
  Description,
  PictureAsPdf,
  Audiotrack,
  Videocam,
  Archive,
  TableChart,
  Slideshow,
} from '@mui/icons-material'

interface FileIconProps {
  type: string
  extension?: string
  size?: number
}

export default function FileIcon({ type, extension, size = 40 }: FileIconProps) {
  if (type === 'directory') {
    return <Folder sx={{ fontSize: size, color: 'primary.main' }} />
  }

  const ext = (extension || '').toLowerCase()

  const iconMap: Record<string, React.ElementType> = {
    jpg: Image,
    jpeg: Image,
    png: Image,
    gif: Image,
    bmp: Image,
    svg: Image,
    pdf: PictureAsPdf,
    txt: Description,
    doc: Description,
    docx: Description,
    xls: TableChart,
    xlsx: TableChart,
    csv: TableChart,
    ppt: Slideshow,
    pptx: Slideshow,
    mp3: Audiotrack,
    wav: Audiotrack,
    ogg: Audiotrack,
    mp4: Videocam,
    avi: Videocam,
    mkv: Videocam,
    mov: Videocam,
    zip: Archive,
    rar: Archive,
    '7z': Archive,
    tar: Archive,
    gz: Archive,
  }

  const IconComponent = iconMap[ext] || InsertDriveFile

  return <IconComponent sx={{ fontSize: size, color: 'text.secondary' }} />
}
